import Image from '@tiptap/extension-image'
import { ReactNodeViewRenderer } from '@tiptap/react'

import { FigureNoCaption } from './FigureComponent'

export const CustomImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: null,
      },
      height: {
        default: null,
      },
    }
  },
  addNodeView() {
    return ReactNodeViewRenderer(FigureNoCaption)
  },
})
